export default __webpack_public_path__ + "static/media/banner.faf693c4.png";